
import { defineComponent } from 'vue'
import User from './User.vue'

export default defineComponent({
  name: 'UsersList',
  components: {
    User
  },
  props: {
    users: Array
  },
  data () {
    return {
      sortingCol: '', // current column that is sorting ('name'/'username')
      sortingOrder: '' // sorting order ('asc'/'desc')
    }
  },
  methods: {
    sortUsers (column: string) {
      // if column clicked is already sorting, just switch asc/desc
      if (this.sortingCol === column) {
        this.sortingOrder = this.sortingOrder === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortingCol = column
        this.sortingOrder = 'asc'
      }

      // init sorting on first click
      if (this.sortingCol === '') {
        this.sortingCol = column
        this.sortingOrder = 'asc'
      }

      this.$emit('sort-users', this.sortingCol, this.sortingOrder)
    },
    getSortingTip (col: string): string {
      if (col === this.sortingCol) {
        return this.sortingOrder === 'asc' ? '▲' : '▼'
      }
      return '▼'
    }
  }
})
